/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMasterClientContentAddPost } from '../fn/client-content/api-master-client-content-add-post';
import { ApiMasterClientContentAddPost$Params } from '../fn/client-content/api-master-client-content-add-post';
import { apiMasterClientContentDeleteGet } from '../fn/client-content/api-master-client-content-delete-get';
import { ApiMasterClientContentDeleteGet$Params } from '../fn/client-content/api-master-client-content-delete-get';
import { apiMasterClientContentEditPost } from '../fn/client-content/api-master-client-content-edit-post';
import { ApiMasterClientContentEditPost$Params } from '../fn/client-content/api-master-client-content-edit-post';
import { apiMasterClientContentGetActiveGet } from '../fn/client-content/api-master-client-content-get-active-get';
import { ApiMasterClientContentGetActiveGet$Params } from '../fn/client-content/api-master-client-content-get-active-get';
import { apiMasterClientContentGetAllGet } from '../fn/client-content/api-master-client-content-get-all-get';
import { ApiMasterClientContentGetAllGet$Params } from '../fn/client-content/api-master-client-content-get-all-get';
import { apiMasterClientContentGetByCriteriaPost } from '../fn/client-content/api-master-client-content-get-by-criteria-post';
import { ApiMasterClientContentGetByCriteriaPost$Params } from '../fn/client-content/api-master-client-content-get-by-criteria-post';
import { apiMasterClientContentGetByIdGet } from '../fn/client-content/api-master-client-content-get-by-id-get';
import { ApiMasterClientContentGetByIdGet$Params } from '../fn/client-content/api-master-client-content-get-by-id-get';
import { ClientContent } from '../models/client-content';
import { ClientContentApiRespModel } from '../models/client-content-api-resp-model';
import { StringApiRespModel } from '../models/string-api-resp-model';

@Injectable({ providedIn: 'root' })
export class ClientContentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMasterClientContentAddPost()` */
  static readonly ApiMasterClientContentAddPostPath = '/api/Master/ClientContent/Add';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterClientContentAddPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterClientContentAddPost$Response(params?: ApiMasterClientContentAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientContentApiRespModel>> {
    return apiMasterClientContentAddPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterClientContentAddPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterClientContentAddPost(params?: ApiMasterClientContentAddPost$Params, context?: HttpContext): Observable<ClientContentApiRespModel> {
    return this.apiMasterClientContentAddPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientContentApiRespModel>): ClientContentApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterClientContentEditPost()` */
  static readonly ApiMasterClientContentEditPostPath = '/api/Master/ClientContent/Edit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterClientContentEditPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterClientContentEditPost$Response(params?: ApiMasterClientContentEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientContentApiRespModel>> {
    return apiMasterClientContentEditPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterClientContentEditPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterClientContentEditPost(params?: ApiMasterClientContentEditPost$Params, context?: HttpContext): Observable<ClientContentApiRespModel> {
    return this.apiMasterClientContentEditPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientContentApiRespModel>): ClientContentApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterClientContentDeleteGet()` */
  static readonly ApiMasterClientContentDeleteGetPath = '/api/Master/ClientContent/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterClientContentDeleteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterClientContentDeleteGet$Response(params?: ApiMasterClientContentDeleteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StringApiRespModel>> {
    return apiMasterClientContentDeleteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterClientContentDeleteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterClientContentDeleteGet(params?: ApiMasterClientContentDeleteGet$Params, context?: HttpContext): Observable<StringApiRespModel> {
    return this.apiMasterClientContentDeleteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringApiRespModel>): StringApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterClientContentGetByIdGet()` */
  static readonly ApiMasterClientContentGetByIdGetPath = '/api/Master/ClientContent/GetById';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterClientContentGetByIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterClientContentGetByIdGet$Response(params?: ApiMasterClientContentGetByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientContent>> {
    return apiMasterClientContentGetByIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterClientContentGetByIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterClientContentGetByIdGet(params?: ApiMasterClientContentGetByIdGet$Params, context?: HttpContext): Observable<ClientContent> {
    return this.apiMasterClientContentGetByIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientContent>): ClientContent => r.body)
    );
  }

  /** Path part for operation `apiMasterClientContentGetAllGet()` */
  static readonly ApiMasterClientContentGetAllGetPath = '/api/Master/ClientContent/GetAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterClientContentGetAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterClientContentGetAllGet$Response(params?: ApiMasterClientContentGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientContent>>> {
    return apiMasterClientContentGetAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterClientContentGetAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterClientContentGetAllGet(params?: ApiMasterClientContentGetAllGet$Params, context?: HttpContext): Observable<Array<ClientContent>> {
    return this.apiMasterClientContentGetAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientContent>>): Array<ClientContent> => r.body)
    );
  }

  /** Path part for operation `apiMasterClientContentGetActiveGet()` */
  static readonly ApiMasterClientContentGetActiveGetPath = '/api/Master/ClientContent/GetActive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterClientContentGetActiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterClientContentGetActiveGet$Response(params?: ApiMasterClientContentGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientContent>>> {
    return apiMasterClientContentGetActiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterClientContentGetActiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterClientContentGetActiveGet(params?: ApiMasterClientContentGetActiveGet$Params, context?: HttpContext): Observable<Array<ClientContent>> {
    return this.apiMasterClientContentGetActiveGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientContent>>): Array<ClientContent> => r.body)
    );
  }

  /** Path part for operation `apiMasterClientContentGetByCriteriaPost()` */
  static readonly ApiMasterClientContentGetByCriteriaPostPath = '/api/Master/ClientContent/GetByCriteria';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterClientContentGetByCriteriaPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterClientContentGetByCriteriaPost$Response(params?: ApiMasterClientContentGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientContent>>> {
    return apiMasterClientContentGetByCriteriaPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterClientContentGetByCriteriaPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterClientContentGetByCriteriaPost(params?: ApiMasterClientContentGetByCriteriaPost$Params, context?: HttpContext): Observable<Array<ClientContent>> {
    return this.apiMasterClientContentGetByCriteriaPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientContent>>): Array<ClientContent> => r.body)
    );
  }

}
